import { useMemo } from "react";
import { useQuery } from "react-query";
import { match } from "ts-pattern";
import { useDefaultQueryOptions } from "../../../../../store/client-query";
import { ALL_MERCHANTS } from "../../../../../store/merchants/resources";
import { UsersService } from "../../../../../store/users/service";

export const MerchantName = ({ id }: { id: string }) => {
  const options = useMemo(
    () => ({
      pagination: {
        size: 1000,
        page: 0,
      },
    }),
    []
  );

  const resource = useQuery(
    ALL_MERCHANTS,
    () => UsersService.getAllMerchants(options),
    useDefaultQueryOptions()
  );

  return match(resource)
    .with({ status: "success" }, ({ data }) => (
      <>
        {data.content.find((x) => x.companyDetails?.id === id)?.companyDetails
          ?.name || id}
      </>
    ))
    .otherwise(() => <>{id}</>);
};
